mutation MarkNotificationAllSeen {
    markNotificationAllSeen {
        user {
            id
        }
    }
}
